import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

import { showErrorToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { ISavedSearchWebhookPayload } from "../../types/webhook";
import { savedSearchWebhooksQueryKeys } from "../key-factory/factory";

export const useSaveSavedSearchWebhookMutation = () => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    return useMutation({
        mutationKey: savedSearchWebhooksQueryKeys.save(),
        retry: 2,
        retryDelay: 200,
        mutationFn(payload: ISavedSearchWebhookPayload) {
            return salesApiService.management.createOrUpdateSavedSearchWebhook(payload);
        },
        onSuccess() {
            queryClient.invalidateQueries({
                queryKey: savedSearchWebhooksQueryKeys.list(),
                refetchType: "inactive",
            });
        },
        onError() {
            dispatch(
                showErrorToast(
                    getToastItemComponent({
                        text: translate("si.management.saved-search-webhooks.save-failed"),
                    }),
                ),
            );
        },
    });
};
